module.exports = __webpack_public_path__ + "static/img/131_TO8_1687.b8b66ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/131_TO8_1687.jpg
// module id = vfZx
// module chunks = 0